import '@Partials/_ComStyles.scss';
import '@Partials/_SimpleStyles.scss';
import './BorderBlueButtonV2.scss';

export default function BorderBlueButtonV2(props){

    const className = 'button__borderBlueButtonV2';
    const mergedClassName = className
        + (props.disabled ? '__disabled' : '')
        + (props.className ? ' ' + props.className : '');

    return (
        <button onClick={props.onClick} className={mergedClassName} disabled={props.disabled}>
            {props.text}
        </button>
    );
}
